export default __webpack_public_path__ + "static/media/ecommerce-landingpage.c40e700d.png";